import { MainLayout } from '../layouts'
import overview from '@/assets/icons/sidebar/overview.svg'
import fieldWork from '@/assets/icons/sidebar/field-work.svg'
import loss from '@/assets/icons/sidebar/loss.svg'
import project from '@/assets/icons/sidebar/project.svg'
import anomalyMonitoring from '@/assets/icons/sidebar/anomaly-monitoring.svg'

import networkManagement from '@/assets/icons/sidebar/network-management.svg'
import operation from '@/assets/icons/sidebar/operation.svg'
import pipeline from '@/assets/icons/sidebar/pipeline.svg'
import { RouterName, UriRole } from '@/routes/config.ts'

export const routes = [
  {
    path: '/',
    name: RouterName.HOME,
    component: MainLayout,
    redirect: '/welcome',
    hidden: false,
    meta: {
      title: 'Trang chủ',
      page: 'home'
    },
    children: [
      {
        hidden: true,
        path: '/welcome',
        name: RouterName.WELCOME,
        component: () => import('@/views/Welcome.vue'),
        meta: {
          page: 'welcome'
        }
      },
      {
        hidden: true,
        path: '/map-mb',
        name: RouterName.MAP_MOBILE,
        component: () => import('@/views/map-in-mobile/index.vue'),
        meta: {
          page: 'map'
        }
      },
      {
        path: '/dashboard',
        name: RouterName.DASHBOARD,
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
          title: 'Tổng quan',
          icon: overview,
          page: 'dashboard'
        },
        hidden: false,
        children: [
          {
            path: '/dashboard/water-supply-network',
            name: RouterName.DASHBOARD_WATER_SUPPLY_NETWORK,
            component: () => import('@/views/dashboard/water-supply-network/index.vue'),
            meta: {
              title: 'Bản đồ vận hành mạng lưới cấp nước ',
              icon: overview,
              uriRole: UriRole.DASHBOARD_WATER_SUPPLY_AREA
            }
          },

          {
            path: '/dashboard/water-loss',
            name: RouterName.DASHBOARD_WATER_LOSS_MAP,
            component: () => import('@/views/dashboard/dashboard-water-loss/index.vue'),
            meta: {
              title: 'Bản đồ thất thoát theo địa bàn',
              uriRole: UriRole.DASHBOARD_WATER_LOSS
            }
          },

          {
            path: '/dashboard/dmx-pressure',
            name: RouterName.DASHBOARD_DMX_PRESSURE,
            component: () => import('@/views/dashboard/dashboard-dmx-pressure/index.vue'),
            meta: {
              title: 'Bản đồ áp lực theo địa bàn',
              uriRole: UriRole.DASHBOARD_DMX_PRESSURE
            }
          },
          {
            path: '/dashboard/pressure-map-by-egion',
            name: RouterName.DASHBOARD_PRESSURE_MAP_BY_REGION,
            component: () => import('@/views/CommingSoon.vue'),
            meta: {
              title: 'Bản đồ áp lực theo địa bàn'
            }
          },
          {
            path: '/dashboard/consumption-production-map-by-region',
            name: RouterName.DASHBOARD_CONSUMPTION_PRODUCTION_MAP,
            component: () => import('@/views/CommingSoon.vue'),
            meta: {
              title: 'Bản đồ sản lượng tiêu thụ theo địa bàn'
            }
          },
          {
            path: '/dashboard/master-meter-quantity-report',
            name: RouterName.DASHBOARD_MASTER_METER_QUANTITY_REPORT,
            component: () => import('@/views/dashboard/master-meter-quantity-report/index.vue'),
            meta: {
              title: 'Báo cáo sản lượng đồng hồ tổng',
              uriRole: UriRole.DASHBOARD_MASTER_METER_QUANTITY_REPORT
            }
          },
          // {
          //   path: '/dashboard/anomaly-monitoring/flowing',
          //   name: RouterName.ANOMALY_MONITORING_PAGE,
          //   redirect: '/anomaly-monitoring/alert',
          //   component: () => import('@/views/anomaly-monitoring/alert/index.vue'),
          //   meta: {
          //     title: 'Theo dõi bất thường trên mạng lưới'
          //   }
          // },
          {
            path: '/dashboard/pressure-sensor-data-report',
            name: RouterName.DASHBOARD_PRESSURE_SENSOR_DATA_REPORT,
            component: () => import('@/views/CommingSoon.vue'),
            meta: {
              title: 'Báo cáo dữ liệu cảm biến áp lực'
            }
          },
          {
            path: '/dashboard/consumption-correlation-chart',
            name: RouterName.DASHBOARD_CONSUMPTION_CORRELATION_CHART,
            component: () => import('@/views/dashboard/consumption-correlation-chart/index.vue'),
            meta: {
              title: 'Biểu đồ tương quan nguồn cấp và tiêu thụ'
            }
          }
        ]
      },
      {
        path: '/pipeline-infrastructure',
        name: RouterName.PIPELINE_INFRASTRUCTURE,
        component: () => import('@/views/pipeline-infrastructure/index.vue'),
        hidden: false,
        meta: {
          title: 'Hạ tầng tuyến ống',
          icon: pipeline,
          page: 'pipeline-infrastructure'
        },
        children: [
          {
            path: '/pipeline-infrastructure/pipe',
            name: RouterName.PIPELINE_INFRASTRUCTURE_PIPELINE,
            component: () => import('@/views/pipeline-infrastructure/pipe/index.vue'),
            meta: {
              title: 'Quản lý thông tin tuyến ống',
              uriRole: UriRole.PIPELINE_INFRASTRUCTURE
            }
          }
        ]
      },
      {
        path: '/network-management',
        name: RouterName.NETWORK_MANAGEMENT,
        component: () => import('@/views/network-management/index.vue'),
        hidden: false,
        meta: {
          title: 'Quản lý mạng lưới',
          icon: networkManagement,
          page: 'network-management'
        },
        children: [
          {
            path: '/network-management/map-partition-management',
            name: RouterName.NETWORK_MANAGEMENT_MAP_PARTITION_MANAGEMENT,
            component: () =>
              import('@/views/network-management/map-partition-management/index.vue'),
            meta: {
              title: 'Quản lý phân vùng bản đồ',
              uriRole: UriRole.MAP_PARTITION_MANAGEMENT
            }
          },
          {
            path: '/network-management/water-supply-area',
            name: RouterName.NETWORK_MANAGEMENT_WATER_SUPPLY_AREA,
            component: () => import('@/views/network-management/water-supply-area/index.vue'),
            meta: {
              title: 'Quản lý khu vực cấp nước',
              uriRole: UriRole.WATER_SUPPLY_AREA
            }
          },
          {
            path: '/network-management/master-meter',
            name: RouterName.NETWORK_MANAGEMENT_MASTER_METER,
            component: () => import('@/views/network-management/master-meter/index.vue'),
            meta: {
              title: 'Quản lý đồng hồ tổng',
              uriRole: UriRole.MASTER_METER
            }
          },
          {
            path: '/network-management/data-logger',
            name: RouterName.NETWORK_MANAGEMENT_DATALOGGER,
            component: () => import('@/views/network-management/data-logger/index.vue'),
            meta: {
              title: 'Quản lý datalogger',
              uriRole: UriRole.DATA_LOGGER
            }
          },
          {
            path: '/network-management/valve-catalog',
            name: RouterName.NETWORK_MANAGEMENT_VALVE_CATALOG,
            component: () => import('@/views/network-management/valve-catalog/index.vue'),
            meta: {
              title: 'Quản lý van'
            }
          },
          {
            path: '/network-management/sensor',
            name: RouterName.NETWORK_MANAGEMENT_SENSOR,
            component: () => import('@/views/network-management/sensor/index.vue'),
            meta: {
              title: 'Quản lý cảm biến áp lực',
              uriRole: UriRole.SENSOR
            }
          },
          {
            path: '/network-management/meter-customer-manage',
            name: RouterName.NETWORK_MANAGEMENT_METER_CUSTOMER,
            component: () => import('@/views/network-management/meter-customer-manage/index.vue'),
            meta: {
              title: 'Quản lý đồng hồ khách hàng'
            }
          },
          {
            path: '/network-management/factory-pumping-station',
            name: RouterName.NETWORK_MANAGEMENT_FACTORY_PUMPING_STATION,
            component: () => import('@/views/network-management/factory-pumping-station/index.vue'),
            meta: {
              title: 'Quản lý Nhà máy nước / Trạm xử lý / Trạm tăng áp '
            }
          },
          {
            path: '/network-management/adm-boundary',
            name: RouterName.NETWORK_MANAGEMENT_ADM_BOUNDARY,
            component: () => import('@/views/network-management/adm-boundary/index.vue'),
            meta: {
              title: 'Địa giới hành chính'
            }
          }
        ]
      },
      {
        path: '/operation',
        name: RouterName.OPERATION,
        component: () => import('@/views/operation/index.vue'),
        hidden: false,
        meta: {
          title: 'Vận hành theo nhu cầu',
          icon: operation,
          page: 'operation'
        },
        children: [
          {
            path: '/operation/configuration',
            name: RouterName.OPERATION_CONFIGURATION,
            component: () => import('@/views/operation/configuration/index.vue'),
            meta: {
              title: 'Cài đặt chế độ vận hành'
            }
          }
        ]
      },
      {
        path: '/anomaly-monitoring',
        name: RouterName.ANOMALY_MONITORING,
        component: () => import('@/views/anomaly-monitoring/index.vue'),
        hidden: false,
        meta: {
          title: 'Theo dõi bất thường',
          icon: anomalyMonitoring,
          page: 'anomaly-monitoring'
        },
        children: [
          {
            path: '/anomaly-monitoring/alert-group',
            name: RouterName.ANOMALY_MONITORING_ALERT_GROUP,
            component: () => import('@/views/anomaly-monitoring/alert-group/index.vue'),
            meta: {
              title: 'Quản lý danh mục cảnh báo',
              uriRole: UriRole.ANOMALY_MONITORING_ALERT_GROUP
            }
          },
          {
            path: '/anomaly-monitoring/manage-time-use-water',
            name: RouterName.ANOMALY_MONITORING_MANAGE_TIME_USE_WATER,
            component: () => import('@/views/anomaly-monitoring/manage-time-use-water/index.vue'),
            meta: {
              title: 'Quản lý khung giờ sử dụng nước'
            }
          },
          {
            path: '/anomaly-monitoring/alert',
            name: RouterName.ANOMALY_MONITORING_ALERT,
            component: () => import('@/views/anomaly-monitoring/alert/index.vue'),
            redirect: '/anomaly-monitoring/alert/warning-statistics',
            meta: {
              title: 'Danh sách cảnh báo'
            },
            children: [
              {
                path: '/anomaly-monitoring/alert/warning-statistics',
                name: RouterName.ANOMALY_MONITORING_ALERT_WARNING_STATISTICS,
                component: () =>
                  import('@/views/anomaly-monitoring/alert/warning-statistics/index.vue'),
                meta: {
                  title: 'Nhóm theo loại cảnh báo',
                  uriRole: UriRole.ANOMALY_MONITORING_ALERT_GROUP
                }
              },
              {
                path: '/anomaly-monitoring/alert/list',
                name: RouterName.ANOMALY_MONITORING_ALERT_LIST,
                component: () => import('@/views/anomaly-monitoring/alert/alert-page/index.vue'),
                meta: {
                  title: 'Chi tiết danh sách cảnh báo',
                  uriRole: UriRole.ANOMALY_MONITORING_ALERT
                }
              },
              {
                path: '/anomaly-monitoring/alert/general',
                name: RouterName.ANOMALY_MONITORING_ALERT_GENERAL,
                component: () => import('@/views/anomaly-monitoring/alert/general/index.vue'),
                meta: {
                  uriRole: UriRole.ANOMALY_MONITORING_ALERT_STATS_DNP
                }
              },
              {
                path: '/anomaly-monitoring/alert/dmx',
                name: RouterName.ANOMALY_MONITORING_ALERT_DMX,
                component: () => import('@/views/anomaly-monitoring/alert/dmx/index.vue'),
                meta: {
                  uriRole: UriRole.ANOMALY_MONITORING_ALERT_STATS_DMX
                }
              }
            ]
          },
          {
            path: '/anomaly-monitoring/tracking-prod-nighttime',
            name: RouterName.ANOMALY_MONITORING_TRACKING_PROD_NIGHTTIME,
            component: () => import('@/views/anomaly-monitoring/tracking-prod-nighttime/index.vue'),
            meta: {
              title: 'Bảng theo dõi sản lượng nền đêm'
            }
          },
          {
            path: '/anomaly-monitoring/flowing',
            name: RouterName.ANOMALY_MONITORING_FLOW,
            component: () => import('@/views/anomaly-monitoring/anomaly-monitoring/index.vue'),
            meta: {
              title: 'Theo dõi bất thường trên mạng lưới'
            }
          }
        ]
      },
      {
        path: '/field-work',
        name: RouterName.FIELDWORK,
        component: () => import('@/views/field-work/index.vue'),
        hidden: false,
        meta: {
          title: 'Công việc hiện trường',
          icon: fieldWork,
          page: 'field-work'
        },
        children: [
          {
            path: '/field-work/ticket-group',
            name: RouterName.FIELDWORK_TICKET_GROUP,
            component: () => import('@/views/field-work/ticket-group/index.vue'),
            meta: {
              title: 'Danh mục nhóm công việc',
              uriRole: UriRole.FIELDWORK_TICKET_GROUP
            }
          },
          {
            path: '/field-work/ticket-type',
            name: RouterName.FIELDWORK_TICKET_TYPE,
            component: () => import('@/views/field-work/ticket-type/index.vue'),
            meta: {
              title: 'Danh mục loại công việc',
              uriRole: UriRole.FIELDWORK_TICKET_TYPE
            }
          },
          {
            path: '/field-work/ticket-type-org',
            name: RouterName.FIELDWORK_TICKET_TYPE_ORG,
            component: () => import('@/views/field-work/ticket-type-org/index.vue'),
            meta: {
              title: 'Danh mục loại công việc theo đơn vị',
              uriRole: UriRole.FIELDWORK_TICKET_TYPE_ORG
            }
          },
          {
            path: '/field-work/ticket/list',
            name: RouterName.FIELDWORK_TICKET_MANAGE,
            component: () => import('@/views/field-work/ticket-manage/index.vue'),
            meta: {
              title: 'Quản lý phơi phiếu',
              hasMobilePage: true
              // uriRole: UriRole.FIELDWORK_TICKET_MANAGE
            }
          },
          {
            path: '/field-work/ticket/:id',
            name: RouterName.FIELDWORK_TICKET_DETAIL,
            component: () => import('@/views/field-work/ticket-manage/ticket-detail/index.vue'),
            meta: {
              title: 'Chi tiết phơi phiếu',
              hasMobilePage: true
              // uriRole: UriRole.TICKET_DETAIL
            }
          },
          {
            path: '/field-work/quota-norm',
            name: RouterName.FIELDWORK_QUOTA_NORM,
            component: () => import('@/views/field-work/quota-norm/index.vue'),
            meta: {
              title: 'Cấu hình chung theo đơn vị'
              // uriRole:
            }
          },
          {
            path: '/field-work/piece-wage/list',
            name: RouterName.FIELDWORK_PIECE_WAGE_MANAGE,
            component: () => import('@/views/field-work/piece-wage-manage/list/index.vue'),
            meta: {
              title: 'Quản lý khoán công việc',
              page: 'salary-table'
              // uriRole: UriRole.FIELDWORK_PIECE_WAGE_MANAGE
            }
          },
          {
            path: '/field-work/piece-wage/detail/:id',
            name: RouterName.FIELDWORK_PIECE_WAGE_DETAIL,
            component: () => import('@/views/field-work/piece-wage-manage/detail/index.vue'),
            hidden: false,
            meta: {
              title: 'Chi tiết bảng lương khoán',
              page: 'salary-table'
              // uriRole: UriRole.FIELDWORK_PIECE_WAGE_MANAGE
            }
          }
        ]
      },

      {
        path: '/loss-support',
        name: RouterName.LOSS_SUPPORT,
        component: () => import('@/views/loss-support/index.vue'),
        hidden: false,
        meta: {
          title: 'Hỗ trợ chống thất thoát',
          icon: loss,
          page: 'loss-support'
        },
        children: [
          {
            path: '/loss-support/territorial-losses',
            name: RouterName.LOSS_SUPPORT_TERRITORIAL_LOSSES,
            component: () => import('@/views/loss-support/data-loss-by-dmx/index.vue'),
            meta: {
              title: 'Bảng tính thất thoát theo địa bàn'
            }
          },
          {
            path: '/loss-support/input-water-data',
            name: RouterName.LOSS_SUPPORT_INPUT_WATER_DATA,
            component: () => import('@/views/loss-support/input-water-data/index.vue'),
            meta: {
              title: 'Bảng tính Sản lượng đồng hồ nước cấp vào'
            }
          },
          {
            path: '/loss-support/water-consumption-data',
            name: RouterName.LOSS_SUPPORT_WATER_CONSUMPTION_DATA,
            component: () => import('@/views/loss-support/water-consumption-data/index.vue'),
            meta: {
              title: 'Bảng tính Sản lượng đồng hồ tiêu thụ'
            }
          },
          {
            path: '/loss-support/water-supply-output',
            name: RouterName.LOSS_SUPPORT_WATER_SUPPLY_OUTPUT,
            component: () => import('@/views/loss-support/water-supply-output/index.vue'),
            meta: {
              title: 'Bảng tính chênh lệch sản lượng'
            }
          },
          {
            path: '/loss-support/meter-customer-data',
            name: RouterName.LOSS_SUPPORT_METER_CUSTOMER_DATA,
            component: () => import('@/views/loss-support/meter-customer-data/index.vue'),
            meta: {
              title: 'Dữ liệu tiêu thụ đồng hồ khách hàng'
            }
          },
          {
            path: '/loss-support/meter-quantity',
            name: RouterName.LOSS_SUPPORT_METER_QUANTITY,
            component: () => import('@/views/loss-support/meter-quantity-dma/index.vue'),
            meta: {
              title: 'Cập nhật Số liệu sản lượng đồng hồ'
            }
          },
          {
            path: '/loss-support/meter-quantity-source',
            name: RouterName.LOSS_SUPPORT_METER_QUANTITY_SOURCE,
            component: () => import('@/views/loss-support/meter-quantity-source/index.vue'),
            meta: {
              title: 'Cập nhật Số liệu sản lượng đồng hồ nguồn cấp'
            }
          },
          {
            path: '/loss-support/loss-deduct-type',
            name: RouterName.LOSS_SUPPORT_LOSS_DEDUCT_TYPE,
            component: () => import('@/views/loss-support/loss-deduct-type/index.vue'),
            meta: {
              title: 'Cấu hình các loại giảm trừ thất thoát'
            }
          },
          {
            path: '/loss-support/dmx-loss-deduct',
            name: RouterName.LOSS_SUPPORT_DMX_LOSS_DEDUCT,
            component: () => import('@/views/loss-support/dmx-loss-deduct/index.vue'),
            meta: {
              title: 'Giảm trừ thất thoát'
            }
          },
          {
            path: '/loss-support/dmx-data-loss',
            name: RouterName.LOSS_SUPPORT_DATA_LOSS_BY_DMX,
            component: () => import('@/views/loss-support/dmx-loss-deduct/index.vue'),
            meta: {
              title: 'Bảng tính giảm trừ thất thoát'
            }
          },
          {
            path: '/loss-support/network-anomaly',
            name: RouterName.LOSS_SUPPORT_NETWORK_ANOMALY,
            component: () => import('@/views/CommingSoon.vue'),
            meta: {
              title: 'Bất thường trên mạng lưới'
            }
          },
          {
            path: '/loss-support/network-anomaly-monitoring-alert-group',
            name: RouterName.LOSS_SUPPORT_NETWORK_ANOMALY_MONITORING,
            component: () => import('@/views/CommingSoon.vue'),
            meta: {
              title: 'Theo dõi bất thường trên mạng lưới'
            }
          },
          {
            path: '/loss-support/declaration-of-anomaly-rules',
            name: RouterName.LOSS_SUPPORT_NETWORK_DECLARATION_ANOMALY_RULES,
            component: () => import('@/views/CommingSoon.vue'),
            meta: {
              title: 'Khai báo quy tắc bất thường '
            }
          },
          {
            path: '/loss-support/nighttime-production',
            name: RouterName.LOSS_SUPPORT_NETWORK_NIGHTTIME_PRODUCTION,
            component: () => import('@/views/CommingSoon.vue'),
            meta: {
              title: 'Bảng theo dõi sản lượng nền đêm\n '
            }
          }
        ]
      },
      {
        path: '/project-management',
        name: RouterName.PROJECT_MANAGEMENT,
        component: () => import('@/views/CommingSoon.vue'),
        hidden: false,
        meta: {
          title: 'Quản lý dự án',
          icon: project,
          page: 'project-management'
        }
      }
    ]
  },
  {
    path: '/login',
    name: RouterName.LOGIN,
    component: () => import('@/views/auth/Login.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: RouterName.NOT_FOUND,
    component: () => import('@/views/exception/404.vue')
  },
  {
    path: '/403',
    name: RouterName.NOT_HAVE_PERMISSION,
    component: () => import('@/views/exception/403.vue')
  }
]
